import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type VisibilityOptions = "Everyone" | "People You Follow" | "Community";

export type CommentFormState = {
    open: boolean;
    post: string;
    emoji: string;
    gif: string;
    openGif: boolean;
    openEmoji: boolean;
};

const initialState: CommentFormState = {
    open: false,
    post: "",
    emoji: "",
    gif: "",
    openGif: false,
    openEmoji: false
};

export const commentFormSlice = createSlice({
    name: "commentFrom",
    initialState,
    reducers: {
        openForm: (state) => {
            state.open = true;
        },
        // eslint-disable-next-line no-unused-vars
        closeForm: (state) => {
            return (state = initialState);
        },
        setEmoji: (state, action: PayloadAction<string>) => {
            state.emoji = action.payload;
            state.openEmoji = false;
        },
        setGif: (state, action: PayloadAction<string>) => {
            state.gif = action.payload;
            state.openGif = false;
        },
        openGifModal: (state) => {
            state.openGif = true;
        },
        closeGifModal: (state) => {
            state.openGif = false;
        },
        openEmojiModal: (state) => {
            state.openEmoji = true;
        },
        closeEmojiodal: (state) => {
            state.openEmoji = false;
        }
    }
});

export const {
    openForm,
    closeForm,
    setEmoji,
    setGif,
    openGifModal,
    closeGifModal,
    openEmojiModal,
    closeEmojiodal
} = commentFormSlice.actions;

export default commentFormSlice.reducer;
